export default ({
  service,
  request,
  serviceForMock,
  requestForMock,
  tools
}) => ({
  // 游戏数据 
  productsAll(data = {}) {
    return request({
      url: '/api/products/all',
      method: 'get',
      params: data
    })
  },
})